import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "mt-3" }
const _hoisted_2 = {
  key: 0,
  class: "text-center text-muted py-4"
}
const _hoisted_3 = {
  key: 1,
  class: "overflow-auto"
}
const _hoisted_4 = { class: "table table-striped border-light" }
const _hoisted_5 = { class: "text-capitalize-first" }
const _hoisted_6 = { class: "text-capitalize-first" }
const _hoisted_7 = { class: "text-capitalize-first" }
const _hoisted_8 = {
  key: 0,
  class: "text-capitalize-first"
}
const _hoisted_9 = { class: "text-nowrap align-top" }
const _hoisted_10 = { class: "align-top" }
const _hoisted_11 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_12 = {
  key: 2,
  class: "text-muted d-block"
}
const _hoisted_13 = { class: "align-top" }
const _hoisted_14 = { class: "d-flex flex-column" }
const _hoisted_15 = { class: "text-muted" }
const _hoisted_16 = { class: "mb-0 mt-1 small text-danger" }
const _hoisted_17 = { class: "mb-0 small text-success" }
const _hoisted_18 = { class: "text-danger" }
const _hoisted_19 = { class: "text-success" }
const _hoisted_20 = {
  key: 0,
  class: "align-top text-nowrap"
}
const _hoisted_21 = ["title"]
const _hoisted_22 = {
  key: 1,
  class: "text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserNameLabel = _resolveComponent("UserNameLabel")!
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.modalTitle,
    "dialog-class": "modal-xl",
    modelValue: _ctx.historyModal,
    "body-class": "pt-0",
    "footer-class": "d-flex justify-content-end",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.historyModal = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_LoaderWrapper, { ref: "loader" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.historyResponse.items.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.helper.trans('labels.no_history')), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("table", _hoisted_4, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.helper.trans('labels.created_at')), 1),
                        _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.helper.trans('labels.initiator')), 1),
                        _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.helper.trans('labels.field')), 1),
                        (_ctx.showFirstDealColumn)
                          ? (_openBlock(), _createElementBlock("th", _hoisted_8, _toDisplayString(_ctx.helper.trans('labels.first_deal')), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedHistory, (group) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: group.changeGroupId
                        }, [
                          _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.dateHelper.format(group.changedAt)), 1),
                          _createElementVNode("td", _hoisted_10, [
                            (group.initiator)
                              ? (_openBlock(), _createBlock(_component_UserNameLabel, {
                                  key: 0,
                                  user: group.initiator
                                }, null, 8, ["user"]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.helper.trans('labels.deleted_user')), 1)),
                            (group.changes.length > 1)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_ctx.helper.trans('labels.fields_changed_count', { count: group.changes.length })), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.changes, (change) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: change.id,
                                  class: "mb-1"
                                }, [
                                  _createElementVNode("small", null, [
                                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.formatFieldName(change.fieldName)), 1),
                                    _cache[6] || (_cache[6] = _createTextVNode(": ")),
                                    (_ctx.isJsonChange(change))
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createElementVNode("pre", _hoisted_16, _toDisplayString(_ctx.formatValue(change.fieldName, change.oldValue)), 1),
                                          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-muted my-1" }, [
                                            _createElementVNode("i", { class: "fa fa-arrow-right" })
                                          ], -1)),
                                          _createElementVNode("pre", _hoisted_17, _toDisplayString(_ctx.formatValue(change.fieldName, change.newValue)), 1)
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.formatValue(change.fieldName, change.oldValue)), 1),
                                          _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fa fa-arrow-right mx-1 text-muted" }, null, -1)),
                                          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.formatValue(change.fieldName, change.newValue)), 1)
                                        ], 64))
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]),
                          (_ctx.showFirstDealColumn)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_20, [
                                (group.firstDealPublicId)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _withDirectives((_openBlock(), _createElementBlock("span", {
                                        title: group.firstDealPublicId
                                      }, [
                                        _createTextVNode(_toDisplayString(group.firstDealPublicId), 1)
                                      ], 8, _hoisted_21)), [
                                        [
                                          _directive_b_tooltip,
                                          void 0,
                                          void 0,
                                          { hover: true }
                                        ]
                                      ]),
                                      _createVNode(_component_copy_button, {
                                        class: "ms-1",
                                        value: group.firstDealPublicId
                                      }, null, 8, ["value"])
                                    ], 64))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_22, "—"))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]),
                  (_ctx.historyResponse.totalCount > _ctx.historyResponse.items.length)
                    ? (_openBlock(), _createBlock(_component_b_pagination, {
                        key: 0,
                        modelValue: _ctx.historyPage,
                        "onUpdate:modelValue": [
                          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.historyPage) = $event)),
                          _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadHistory()))
                        ],
                        "total-rows": _ctx.historyResponse.totalCount,
                        "per-page": _ctx.historyResponse.limit,
                        limit: 20,
                        "prev-text": "Back",
                        "next-text": "Next",
                        align: "start",
                        "first-number": "",
                        "hide-goto-end-buttons": "",
                        "hide-ellipsis": ""
                      }, null, 8, ["modelValue", "total-rows", "per-page"]))
                    : _createCommentVNode("", true)
                ]))
          ])
        ]),
        _: 1
      }, 512)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.historyModal = false), ["prevent"])),
        class: "btn btn-outline-dark btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.helper.trans('button.close')), 1)
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}